'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["offsetTop"];
let _ = t => t,
  _t;
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { createGlobalStyle } from 'styled-components';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import { OLAF } from 'HubStyleTokens/colors';
import UILayer from 'UIComponents/layer/UILayer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileLayerGlobalStyle = createGlobalStyle(_t || (_t = _`
  html body {
    overflow: hidden !important;
  }
  .mobile-layer-inner {
    position: fixed;
    top: ${0};
    bottom: 0;
    width: 100vw;
    z-index: ${0};
    background-color: ${0};
    overflow: scroll;
  }
`), props => props.offsetTop, URANUS_LAYER, OLAF);
const MobileLayer = _ref => {
  let {
      offsetTop
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobileLayerGlobalStyle, {
      offsetTop: offsetTop
    }), /*#__PURE__*/_jsx(UILayer, Object.assign({}, props, {
      size: 'large',
      children: /*#__PURE__*/_jsx("div", {
        className: "mobile-layer-inner",
        children: props.children
      })
    }))]
  });
};
MobileLayer.displayName = 'MobileLayer';
MobileLayer.propTypes = Object.assign({}, UILayer.PropTypes, {
  offsetTop: PropTypes.string
});
export default MobileLayer;